import { CheckCircle } from 'lucide-react';

interface FeatureHighlightsProps {
  /** Section heading - defaults to "Why use this calculator?" */
  heading?: string;
  /** List of feature descriptions to display */
  features: string[];
}

/**
 * SEO-friendly feature highlights section.
 * Displays a list of features with checkmark icons for better visual appeal.
 * Static HTML content helps Google index the page properly.
 */
export function FeatureHighlights({
  heading = 'Why use this calculator?',
  features,
}: FeatureHighlightsProps): React.JSX.Element {
  return (
    <section className="bg-gray-50 rounded-lg p-4 md:p-6">
      <h2 className="text-lg font-semibold mb-3">{heading}</h2>
      <ul className="space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <CheckCircle
              className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5"
              aria-hidden="true"
            />
            <span className="text-gray-700">{feature}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
